import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import Map from './Map'

const useStyles = makeStyles((theme) => {
  const mobile = theme.breakpoints.down(900)
  const desktop = theme.breakpoints.up(900)

  return {
    container: {
      height: '650px',
      maxHeight: '90vh',
      [mobile]: { overflow: 'auto' },
      [desktop]: { width: '1000px', maxWidth: '95vw' },
    },
    mapContainer: {
      position: 'relative',
      backgroundColor: '#f0f0f0',
      [mobile]: { display: 'none' },
      [desktop]: {
        width: '70%',
        display: 'block',
        borderRadius: '0 2.4rem 2.4rem 0',
        overflow: 'hidden',
      },
    },
    content: {
      backgroundColor: 'white',
      overflow: 'auto',
      padding: '3rem',
      [mobile]: {
        margin: 'auto',
        borderRadius: '2.4rem',
        width: 'calc(100vw - 50px)',
        height: '100%',
      },
      [desktop]: { width: '50%', borderRadius: '2.4rem 0 0 2.4rem' },
    },
  }
})

const MapContainer = ({ children, className, location, onLocationChange }) => {
  const classes = useStyles()

  return (
    <div className={clsx(className, classes.container)}>
      <div className="flex h-full">
        <div className={classes.content}>{children}</div>
        <div className={classes.mapContainer}>
          <Map
            id="on-board-googlemap-desktop"
            className="h-full w-full"
            location={location}
            onLocationChange={onLocationChange}
          />
        </div>
      </div>
    </div>
  )
}

MapContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  location: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
    lng: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
  onLocationChange: PropTypes.func,
}

export default MapContainer
